/**
 * Game launcher.
 *
 * @module app/components/crossSell/games/Launcher
 */
import Game from '../../crossSell/games/Game';
import GameAPI from '../../crossSell/games/API';

/**
 * Launched game instances.
 * @type {Object}
 * @private
 */
var games = {};

export default {

    launch: function launch(gameUrl) {

        GameAPI.init(window.WH.messageBus);

        if (!games[gameUrl]) {
            games[gameUrl] = new Game(window.WH.messageBus, gameUrl);
        }

        games[gameUrl].open();
    },
};

